import NextLink from 'next/link';
import React from 'react';

import { linkResolver } from '@/helpers/storyblok/link-resolver';

import { DEFAULT_LOCALE } from '../../config/index.js';

export const Link = ({
  className,
  children,
  link,
  page,
  disabled,
  timeout = null,
  offsetElement = null,
  ...props
}) => {
  let href = props.href || linkResolver(link, page);

  const urlParams = href.split('/');
  if (urlParams[0] === '') urlParams.shift();
  if (urlParams[0].toLowerCase() === DEFAULT_LOCALE.shortCode.toLowerCase()) {
    urlParams.shift();
    href = `/${urlParams.join('/')}`;
  }

  const openCookieConsent = () => {
    window.CookieConsentApi.showSettings();
  };

  if (href === '#cookie-consent-popup') {
    return (
      <button onClick={openCookieConsent} className={className} {...props}>
        {children}
      </button>
    );
  }

  const target =
    props.target || (href || '').match(/^(https?:)?\/\//) ? '_blank' : null;

  const rel = props.rel || target === '_blank' ? 'noopener noreferrer' : null;

  const handleClick = (event) => {
    if (timeout && timeout.function && typeof timeout.function === 'function') {
      setTimeout(() => {
        timeout.function();
      }, timeout.time || 200);
    }

    if (href.startsWith('#')) {
      event.preventDefault();

      if (href === '#EditPrefCookie') {
        openCookieConsent();
        return;
      }

      const target = document.querySelector(href);

      if (target) {
        const targetScrollOffsetTop =
          parseInt(
            window
              .getComputedStyle(target)
              .getPropertyValue('--js-scroll-offset-top') || '0',
            10,
          ) || 0;

        let top =
          (document.scrollingElement?.scrollTop || 0) +
          target.getBoundingClientRect().top -
          targetScrollOffsetTop;

        if (offsetElement)
          top = top - parseInt(getComputedStyle(offsetElement).height);

        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      }
    }
  };

  return (
    <NextLink
      href={
        href
          ? href.startsWith('#')
            ? href
            : {
                pathname: href,
                query: link?.params || {},
              }
          : ''
      }
      target={target}
      rel={rel}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </NextLink>
  );
};
